import { useCallback, useState } from 'react';
import { Env } from '../../shared';
import { useAdminApi, ApiError } from './client';
import { KillSwitchResponse } from './types';

/**
 * Spin-wheel kill switch (SSA-816 sibling endpoint). The backend is POST-only —
 * it flips the `gamification_spin_wheel` AppConfig flag and returns the new
 * value; there is no GET current-state endpoint, so the panel tracks the last
 * applied value optimistically and starts from unknown.
 */
export function useKillSwitch(env: Env) {
  const { request } = useAdminApi();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const setSpinEnabled = useCallback(
    async (enabled: boolean, reason: string): Promise<KillSwitchResponse | null> => {
      setLoading(true);
      setError(null);
      try {
        return await request<KillSwitchResponse>({
          env,
          path: '/admin/gamification/kill-switch/spin',
          method: 'POST',
          body: { enabled, reason },
        });
      } catch (e) {
        setError(e instanceof ApiError ? e.message : 'Kill-switch toggle failed');
        return null;
      } finally {
        setLoading(false);
      }
    },
    [request, env],
  );

  return { loading, error, setSpinEnabled };
}
